import { render, staticRenderFns } from "./TripAiBot.vue?vue&type=template&id=0ec166c0"
import script from "./TripAiBot.vue?vue&type=script&lang=js"
export * from "./TripAiBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports